(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kaede-site-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('.kaede-site-header__language-form')) return;

    let returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.append(returnTo);
    }
    returnTo.value = window.location.pathname + window.location.search + window.location.hash;
  });

  const updateKaedePreviewLanguages = () => {
    document.querySelectorAll('[data-kaede-language-preview]').forEach((link) => {
      const target = new URL(link.href);
      target.search = window.location.search;
      target.hash = window.location.hash;
      link.href = target.href;
    });
  };
  updateKaedePreviewLanguages();
  window.addEventListener('hashchange', updateKaedePreviewLanguages);
  document.addEventListener('shopify:section:load', updateKaedePreviewLanguages);
  } catch(e) { console.error(e); }
})();

})();
